import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessHour } from 'src/app/models/register-business';

@Component({
  selector: 'app-day-business-hour-item',
  templateUrl: './day-business-hour-item.component.html',
  styleUrls: ['./day-business-hour-item.component.scss']
})
export class DayBusinessHourItemComponent {
  @Input()
  hour: BusinessHour;

  times: string[] = [];
  selectedTime1: string;
  selectedTime2: string;
  timeforFirstSelector: string[] = [];
  timesForSecondSelector: string[] = [];



  ngOnInit() {
    this.generateTimes();
  }

  ChangeSelection(hour) {
    this.hour.isOpen = !this.hour.isOpen;
    this.hour.From = "";
    this.hour.To = "";
  }


  generateTimes() {
    const startTime = new Date();
    startTime.setHours(0, 0, 0, 0);
    for (let i = 0; i < 48; i++) {
      this.times.push(this.formatTime(startTime));
      startTime.setMinutes(startTime.getMinutes() + 30);
    }
    this.timeforFirstSelector = [...this.times];
    this.timesForSecondSelector = [...this.times]; // Initially, the second selector has the same options
  }

  formatTime(date: Date): string {
    let hours = date.getHours();
    let minutes: any = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  onFromTimeSelect() {
    const selectedIndex = this.times.indexOf(this.hour.From);
    if (selectedIndex !== -1) {
      this.timesForSecondSelector = this.times.slice(selectedIndex + 1);
    } else {
      this.timesForSecondSelector = [...this.times];
    }
  }

  onToTimeSelect() {
    const selectedIndex = this.times.indexOf(this.hour.To);
    if (selectedIndex !== -1) {
      this.timeforFirstSelector = this.times.slice(0, selectedIndex);
    } else {
      this.timeforFirstSelector = [...this.times];
    }
  }
}
